import React from 'react';
import { Building2, Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import { contactInfo, companies } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                  <span className="text-slate-900 font-bold text-lg">MR</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold">Martins Ribeiro</h3>
                  <p className="text-slate-400 text-sm">Grupo Empresarial</p>
                </div>
              </div>
              <p className="text-slate-300 leading-relaxed">
                Uma holding familiar consolidada em Goiás há mais de 45 anos, 
                gerenciando empresas de excelência com valores sólidos e compromisso.
              </p>
              <div className="flex items-center space-x-2 text-slate-400">
                <Building2 className="w-4 h-4" />
                <span className="text-sm">Desde 1978</span>
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-6">
              <h4 className="text-lg font-semibold">Navegação</h4>
              <nav className="space-y-3">
                {[
                  { label: 'Início', id: 'inicio' },
                  { label: 'Nossa História', id: 'historia' },
                  { label: 'Nossas Empresas', id: 'empresas' },
                  { label: 'Contato', id: 'contato' }
                ].map((link) => (
                  <button
                    key={link.id}
                    onClick={() => scrollToSection(link.id)}
                    className="block text-slate-300 hover:text-white transition-colors duration-200 text-left"
                  >
                    {link.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Companies */}
            <div className="space-y-6">
              <h4 className="text-lg font-semibold">Nossas Empresas</h4>
              <div className="space-y-3">
                {companies.map((company) => (
                  <div key={company.id} className="group">
                    <h5 className="text-slate-300 group-hover:text-white transition-colors duration-200 font-medium">
                      {company.name}
                    </h5>
                    <p className="text-slate-400 text-sm">{company.category}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Info */}
            <div className="space-y-6">
              <h4 className="text-lg font-semibold">Contato</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-300 text-sm">
                    {contactInfo.address}
                  </span>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-slate-400" />
                  <a 
                    href={`tel:${contactInfo.phone.replace(/\D/g, '')}`}
                    className="text-slate-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {contactInfo.phone}
                  </a>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-slate-400" />
                  <a 
                    href={`mailto:${contactInfo.email}`}
                    className="text-slate-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {contactInfo.email}
                  </a>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-800">
                <p className="text-slate-400 text-sm">
                  {contactInfo.businessHours}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} Grupo Martins Ribeiro. Todos os direitos reservados.
            </p>
            
            <div className="flex items-center space-x-6 text-sm text-slate-400">
              <span>Desenvolvido com dedicação em Goiânia, GO</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;